import React from 'react';
import { useSelector } from 'react-redux';

export default function AvailiableItemTableHeader(props) {
    const wording = useSelector(({ language }) => language.wording);

    return (
        <thead>
            <tr className="cart_header">
                {
                    !props.buyNowStatus && 
                        <th>
                            <input
                                type='checkbox'
                                className='input-checkbox'
                                checked={props.numSelected === props.rowCount}
                                onChange={(e) => props.onSelectAllClick(e.target.checked)}
                            />
                        </th>
                }
                <th className='product-name white' colSpan='2'>
                    {wording.cartPage.avaliableOrder.product}
                </th>
                <th className='product-price white'>{wording.cartPage.avaliableOrder.price}</th>
                <th className='product-quantity white'>{wording.cartPage.avaliableOrder.quantity}</th>
                <th colSpan="2" className='product-subtotal white'>{wording.cartPage.avaliableOrder.total}</th>
            </tr>
        </thead>
    );
}
